import { useAtomValue, useSetAtom } from "jotai";
import { Button, Field, Spinner, Text, TextInput } from "@zapier/design-system";
import { ChangeEvent, useCallback, useState } from "react";
import { canvasAtom, canvasMetaSetter } from "@zapier/canvas-state";

import styles from "./EditDescriptionModalContent.module.css";

type Props = {
  onClosed: () => void;
};

function EditDescriptionModalContent({ onClosed }: Props) {
  const canvas = useAtomValue(canvasAtom);
  const saveMeta = useSetAtom(canvasMetaSetter);

  const [description, setDescription] = useState<string>(
    canvas?.description || "",
  );

  const [isSaving, setIsSaving] = useState(false);

  const onSave = useCallback(async () => {
    setIsSaving(true);
    await saveMeta({
      description,
    });
    setIsSaving(false);
    onClosed();
  }, [description, onClosed, saveMeta]);

  const handleDescriptionChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setDescription(e.target.value);
  };

  return (
    <div className={styles.modalContentWrapper}>
      <div className={styles.fieldWrapper}>
        <Field
          label="Description"
          renderHelpText={() => (
            <Text type="SmallPrint1" color="GrayWarm9">
              Help collaborators understand what this process does.
            </Text>
          )}
          renderInput={(inputProps) => (
            <TextInput
              {...inputProps}
              isMultiline={true}
              value={description}
              onChange={handleDescriptionChange}
            />
          )}
        />
      </div>
      <span className={styles.buttonsWrapper}>
        <Button
          color="primary"
          onClick={onSave}
          size="small"
          disabled={!description.trim() || isSaving}
        >
          {isSaving ? <Spinner /> : "Save changes"}
        </Button>
        <Button color="secondary" onClick={onClosed} size="small">
          Cancel
        </Button>
      </span>
    </div>
  );
}

export default EditDescriptionModalContent;
